import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import getFilePath from "helpers/get-file-path";
import InstagramIcon from "assets/svgs/instagram_icon.svg";

import {
  twoColumns, twoColumnsItems, twoColumnsText,
  twoColumnsVideo, overlapVideo, twoColumnsItemsReverse,
  mediaTwoColumns, twoColumnsTextComplex,
  twoColumnsTextComplexIcon, twoColumnsContainerResponsive,
  wordBreaksOff, videoContainer
} from "./style.mod.scss";
import RichText from "components/rich-text";
import useResponsiveConfig from "hooks/useResponsiveConfig";
import parsePadding from "helpers/parse-padding";
import { lazyLoadVideos } from "helpers/lazyLoadVideos";

const TwoColumns = ({ data }) => {

  const {
    video, alternating, mobileAlternating, overlap, leftAlign,
    instaUrl, showInsta, mobilePadding,
    tabletPadding, desktopPadding
  } = data;

  const disableWordBreak = data?.disableWordBreak;
  const noWordBreaks = disableWordBreak ? wordBreaksOff : "";

  const config = useResponsiveConfig({
    mobile: {
      styles: parsePadding(mobilePadding ? `${mobilePadding}px` : "inherit"),
      className: (mobileAlternating) ? twoColumnsItemsReverse : ""
    },
    tablet: {
      styles: parsePadding(tabletPadding ? `${tabletPadding}px` : "inherit"),
      className: twoColumnsItemsReverse
    },
    desktop: {
      styles: parsePadding(desktopPadding ? `${desktopPadding}px` : "inherit"),
      className: (alternating) ? twoColumnsItemsReverse : ""
    }

  });

  useEffect(() => {
    lazyLoadVideos();
  }, []);

  return (
    <div
      className={`
        ${twoColumns}
        ${leftAlign ? mediaTwoColumns : ""}
        ${overlap ? overlapVideo : ""}
        ${config.className}
      `}
      style={{
        backgroundColor: data.bgColor && data.bgColor.hex,
        ...config.styles
      }}
    >
      <Container className={twoColumnsContainerResponsive}>
        <div className={twoColumnsItems}>
          <div className={twoColumnsText}>
            <div className={`${twoColumnsTextComplex} ${noWordBreaks}`}>
              <RichText blocks={data.text} />
            </div>
          </div>
          <div className={twoColumnsVideo}>
            {video &&
              <div className={videoContainer}>
                <video autoPlay={true} muted={true} playsInline={true} loop>
                  <source data-src={getFilePath(video)} />
                  Sorry, your browser doesnt support embedded videos!
                </video>
                {/* <div style={{ display: videoText ? "block" : "none" }} className={videoCaption}> { videoText } </div> */}
              </div>
            }
            {showInsta &&
              <div className={twoColumnsTextComplexIcon}>
                <a target="_blank" href={instaUrl} rel="noopener noreferrer">
                  <InstagramIcon />
                </a>
              </div>
            }
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TwoColumns;
